import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinbelgaum() {



    const cardData = {




keyword: "Swift Dzire on Rent in Belgaum",

headingDescription: "Belgaum Taxi Service provides affordable Swift Dzire on rent in Belgaum for local travel, airport transfers, railway station pickups, corporate visits, family trips, wedding transportation, and outstation journeys. Maruti Swift Dzire is a popular sedan choice for passengers looking for comfortable seating, good mileage, smooth performance, and economical travel. Whether you need a Swift Dzire for a few hours, full-day rental, one-way cab, round-trip journey, or long-distance travel, we offer well-maintained cars with professional chauffeurs. Our Swift Dzire rental service includes doorstep pickup, flexible booking options, transparent pricing, clean vehicles, punctual service, and 24/7 customer support. Belgaum Taxi Service offers Swift Dzire rental solutions for business travelers, families, and individuals traveling across Karnataka, Goa, Maharashtra, and nearby destinations with a focus on safety, comfort, and convenience.",

topPlaces: [
   {
    title: "Ramdurg",
    description: "Ramdurg is a historic town near Belgaum known for scenic landscapes, forts, and cultural importance. It is a convenient destination for short-distance cab journeys."
  },
  {
    title: "Bailhongal",
    description: "Bailhongal is known for historical attractions, local markets, and its connection with Rani Chennamma's legacy. It is a popular nearby destination from Belgaum."
  },
  {
    title: "Savadatti",
    description: "Savadatti is a popular pilgrimage destination near Belgaum, famous for the Yellamma Temple and surrounding hills. It is a frequently visited location for religious and family trips."
  },
  {
    title: "Nipani",
    description: "Nipani is an important town on the Karnataka-Maharashtra border known for trade, agriculture, and commercial activities. Swift Dzire rentals are suitable for business and personal travel."
  },
 
  {
    title: "Vijayapura",
    description: "Vijayapura is a heritage city famous for Gol Gumbaz, historical monuments, and Islamic architecture. It is a preferred destination for sightseeing and cultural tours."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a nature and adventure destination known for wildlife, river rafting, forests, and trekking activities. It is ideal for travelers planning a comfortable road trip."
  },
  {
    title: "Karwar",
    description: "Karwar is a beautiful coastal destination famous for beaches, islands, temples, and scenic sea views. It is a peaceful getaway for families and tourists."
  },
  {
    title: "Chikmagalur",
    description: "Chikmagalur is a hill station known for coffee plantations, waterfalls, trekking spots, and pleasant weather, making it a popular holiday destination."
  },
  {
    title: "Sangli",
    description: "Sangli is a commercial city in Maharashtra known for agriculture, industries, temples, and business activities. It is a common route for travelers from Belgaum."
  },
  {
    title: "Miraj",
    description: "Miraj is a historic city near Sangli known for healthcare facilities, music heritage, and commercial importance. It is frequently visited for medical and personal travel."
  }
],




"services": [
  {
    "name": "Swift Dzire On Rent in Belgaum",
    "description": "Book Swift Dzire On Rent in Belgaum for comfortable, affordable, and reliable transportation services for local and outstation travel. Our well-maintained Maruti Swift Dzire cars are perfect for family trips, business travel, airport transfers, sightseeing, and daily travel requirements. Enjoy clean AC vehicles, professional drivers, flexible rental options, affordable pricing, doorstep pickup, and safe travel experience with 24x7 booking support."
  },
  {
    "name": "Swift Dzire Rent in Belgaum",
    "description": "Choose Swift Dzire Rent in Belgaum for economical and comfortable cab rental solutions. Our Swift Dzire cars are available for one way trips, round trips, corporate travel, airport pickup and drop, and outstation journeys with experienced chauffeurs, transparent pricing, and hassle-free booking services."
  },
  {
    "name": "Swift Dzire Rental Belgaum",
    "description": "Hire Swift Dzire Rental Belgaum services for smooth and convenient travel across Belgaum and nearby destinations. Get fuel-efficient sedan cars with comfortable seating, luggage space, professional drivers, and flexible rental packages for personal and business travel."
  },
  {
    "name": "Maruti Swift Dzire on Rent Belgaum",
    "description": "Book Maruti Swift Dzire on Rent Belgaum for affordable sedan cab services with premium comfort and reliable performance. Ideal for family outings, office travel, airport transfers, meetings, and outstation trips with experienced drivers and well-maintained vehicles."
  },
  {
    "name": "Swift Dzire Cab Service Belgaum",
    "description": "Get reliable Swift Dzire Cab Service Belgaum for local rides, airport transfers, corporate travel, and long-distance journeys. Our sedan cab services provide comfortable seating, clean interiors, professional chauffeurs, and affordable travel solutions."
  },
  {
    "name": "Swift Dzire Taxi Service Belgaum",
    "description": "Choose Swift Dzire Taxi Service Belgaum for safe and comfortable taxi travel with punctual pickup, experienced drivers, and competitive fares. Perfect for business trips, family travel, city rides, and outstation transportation."
  },
  {
    "name": "Swift Dzire Taxi Belgaum",
    "description": "Book Swift Dzire Taxi Belgaum for convenient sedan transportation with premium comfort, spacious interiors, and reliable chauffeur services. Enjoy smooth rides for airport transfers, local travel, and outstation destinations."
  },
  {
    "name": "Swift Dzire Cab Belgaum",
    "description": "Hire Swift Dzire Cab Belgaum for affordable and comfortable travel with professional drivers and well-maintained vehicles. Our cabs are suitable for personal trips, corporate requirements, family journeys, and tourist travel."
  },
  {
    "name": "Swift Dzire Car Hire Belgaum",
    "description": "Choose Swift Dzire Car Hire Belgaum for flexible rental options with driver assistance. Travel comfortably with clean AC sedan cars, experienced chauffeurs, and reliable service for short and long-distance journeys."
  },
  {
    "name": "Swift Dzire Car Rental Belgaum",
    "description": "Book Swift Dzire Car Rental Belgaum for affordable sedan car rental services with flexible packages. Whether you need a vehicle for business meetings, sightseeing, airport transfers, or outstation travel, we provide comfortable and dependable solutions."
  },
  {
    "name": "Online Swift Dzire Booking Belgaum",
    "description": "Complete Online Swift Dzire Booking Belgaum easily with quick confirmation, flexible travel options, and reliable cab services. Book a comfortable Swift Dzire sedan for local rides, airport transfers, and outstation trips."
  },
  {
    "name": "Swift Dzire with Driver Belgaum",
    "description": "Hire Swift Dzire with Driver Belgaum for stress-free travel with trained chauffeurs and comfortable sedan cars. Our driver-operated service ensures safe journeys, timely pickup, and convenient transportation for every travel need."
  },
  {
    "name": "Swift Dzire for Outstation Belgaum",
    "description": "Book Swift Dzire for Outstation Belgaum for affordable long-distance travel with comfortable seating, experienced drivers, and reliable highway journeys. Ideal for family vacations, business trips, and weekend getaways."
  },
  {
    "name": "Swift Dzire Airport Transfer Belgaum",
    "description": "Choose Swift Dzire Airport Transfer Belgaum for timely airport pickup and drop services with comfortable sedan cars and professional drivers. Enjoy hassle-free airport transportation with affordable fares and smooth travel experience."
  },
  {
    "name": "Swift Dzire Airport Pickup Belgaum",
    "description": "Book Swift Dzire Airport Pickup Belgaum for convenient airport transportation with punctual service, clean vehicles, and experienced chauffeurs. Perfect for individuals, families, and business travelers."
  },
  {
    "name": "Swift Dzire Airport Drop Belgaum",
    "description": "Get Swift Dzire Airport Drop Belgaum services for safe and comfortable airport transfers. Our professional drivers ensure timely arrival, smooth rides, and reliable sedan cab service."
  },
  {
    "name": "Swift Dzire One Way Cab Belgaum",
    "description": "Book Swift Dzire One Way Cab Belgaum for affordable single-trip travel with fixed pricing, comfortable vehicles, and professional drivers. Ideal for airport drops, outstation journeys, and city-to-city travel."
  },
  {
    "name": "Swift Dzire Round Trip Cab Belgaum",
    "description": "Choose Swift Dzire Round Trip Cab Belgaum for return journeys with flexible schedules, affordable packages, and comfortable travel. Perfect for sightseeing, family tours, business trips, and weekend travel."
  },
  {
    "name": "Swift Dzire Tour Package Belgaum",
    "description": "Book Swift Dzire Tour Package Belgaum for comfortable sightseeing and holiday trips. Enjoy customized travel plans, experienced drivers, affordable packages, and convenient transportation for exploring nearby destinations."
  },
  {
    "name": "Belgaum to Goa Swift Dzire Cab",
    "description": "Travel comfortably with Belgaum to Goa Swift Dzire Cab for a safe and affordable journey. Enjoy professional drivers, AC sedan comfort, doorstep pickup, and reliable outstation cab service for Goa travel."
  },
  {
    "name": "Belgaum to Pune Swift Dzire Cab",
    "description": "Book Belgaum to Pune Swift Dzire Cab for comfortable intercity travel with experienced chauffeurs, clean sedan cars, affordable fares, and reliable transportation for business and personal journeys."
  },
  {
    "name": "Belgaum to Mumbai Swift Dzire Cab",
    "description": "Choose Belgaum to Mumbai Swift Dzire Cab for smooth highway travel with professional drivers, comfortable seating, luggage space, and affordable outstation taxi services."
  },
  {
    "name": "Belgaum to Bangalore Swift Dzire Cab",
    "description": "Book Belgaum to Bangalore Swift Dzire Cab for reliable city-to-city travel with comfortable sedan cars, experienced drivers, flexible pickup options, and safe long-distance transportation."
  },
  {
    "name": "Belgaum to Hyderabad Swift Dzire Cab",
    "description": "Travel with Belgaum to Hyderabad Swift Dzire Cab offering comfortable rides, professional chauffeurs, affordable pricing, and dependable outstation cab services for business and family trips."
  },
  {
    "name": "Belgaum to Kolhapur Swift Dzire Cab",
    "description": "Book Belgaum to Kolhapur Swift Dzire Cab for convenient travel with clean AC sedan cars, skilled drivers, affordable fares, and reliable transportation services."
  },
  {
    "name": "Belgaum to Hubli Swift Dzire Cab",
    "description": "Choose Belgaum to Hubli Swift Dzire Cab for comfortable and affordable travel with professional drivers, flexible booking options, and safe highway journeys."
  },
  {
    "name": "Belgaum to Mahabaleshwar Swift Dzire Cab",
    "description": "Book Belgaum to Mahabaleshwar Swift Dzire Cab for a comfortable hill station journey with experienced drivers, smooth travel, affordable packages, and reliable outstation cab service."
  },
  {
    "name": "Belgaum to Shirdi Swift Dzire Cab",
    "description": "Travel with Belgaum to Shirdi Swift Dzire Cab for a peaceful and comfortable pilgrimage journey. Enjoy clean sedan cars, professional drivers, flexible travel plans, and safe transportation."
  },
  {
    "name": "Belgaum Outstation Swift Dzire Cab",
    "description": "Book Belgaum Outstation Swift Dzire Cab for reliable long-distance travel with affordable fares, experienced chauffeurs, comfortable sedan cars, and customized travel solutions."
  }
],

"tableData": [
  ["Swift Dzire On Rent in Belgaum", "Swift Dzire Rent in Belgaum"],
  ["Swift Dzire Rental Belgaum", "Maruti Swift Dzire on Rent Belgaum"],
  ["Swift Dzire Cab Service Belgaum", "Swift Dzire Taxi Service Belgaum"],
  ["Swift Dzire Taxi Belgaum", "Swift Dzire Cab Belgaum"],
  ["Swift Dzire Car Hire Belgaum", "Swift Dzire Car Rental Belgaum"],
  ["Online Swift Dzire Booking Belgaum", "Swift Dzire with Driver Belgaum"],
  ["Swift Dzire for Outstation Belgaum", "Swift Dzire Airport Transfer Belgaum"],
  ["Swift Dzire Airport Pickup Belgaum", "Swift Dzire Airport Drop Belgaum"],
  ["Swift Dzire One Way Cab Belgaum", "Swift Dzire Round Trip Cab Belgaum"],
  ["Swift Dzire Tour Package Belgaum", "Belgaum to Goa Swift Dzire Cab"],
  ["Belgaum to Pune Swift Dzire Cab", "Belgaum to Mumbai Swift Dzire Cab"],
  ["Belgaum to Bangalore Swift Dzire Cab", "Belgaum to Hyderabad Swift Dzire Cab"],
  ["Belgaum to Kolhapur Swift Dzire Cab", "Belgaum to Hubli Swift Dzire Cab"],
  ["Belgaum to Mahabaleshwar Swift Dzire Cab", "Belgaum to Shirdi Swift Dzire Cab"],
  ["Belgaum Outstation Swift Dzire Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Swift Dzire on Rent in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service offers comfortable Maruti Swift Dzire rentals for local travel, airport transfers, corporate trips, family outings, and outstation journeys."
  },
  {
    WhyChooseheading: "Comfortable Sedan for Every Trip",
    WhyChoosedescription: "The Swift Dzire provides a smooth ride, spacious seating, excellent mileage, and comfortable interiors, making it ideal for daily and long-distance travel."
  },
  {
    WhyChooseheading: "Convenient Pickup Across Belgaum",
    WhyChoosedescription: "Get doorstep pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and other preferred locations for a hassle-free journey."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our trained chauffeurs ensure safe driving, punctual service, and a comfortable travel experience with complete customer satisfaction."
  },
  {
    WhyChooseheading: "Ideal for Local & Outstation Travel",
    WhyChoosedescription: "Hire a Swift Dzire for city rides, airport transfers, business meetings, sightseeing, family trips, and outstation routes from Belgaum."
  },
  {
    WhyChooseheading: "Affordable Rental Packages",
    WhyChoosedescription: "Choose flexible one-way, round-trip, hourly, and daily rental options with transparent pricing and reliable service."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Cars",
    WhyChoosedescription: "Every Swift Dzire is regularly serviced, cleaned, and inspected to provide a safe, hygienic, and comfortable journey."
  },
  {
    WhyChooseheading: "24/7 Booking Support",
    WhyChoosedescription: "Book your Swift Dzire rental anytime with quick confirmation and dedicated assistance for smooth travel planning."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Swift Dzire on Rent in Belgaum?",
    answer: "Yes, we provide Swift Dzire rental services in Belgaum for local travel, airport transfers, corporate trips, and outstation journeys."
  },
  {
    question: "Can I rent a Swift Dzire for outstation travel?",
    answer: "Yes, Swift Dzire is available for one-way and round-trip travel to destinations like Goa, Bangalore, Pune, Mumbai, Hubli, and nearby cities."
  },
  {
    question: "How many passengers can travel in Swift Dzire?",
    answer: "The Swift Dzire comfortably accommodates up to 4 passengers with sufficient luggage space for a comfortable journey."
  },
  {
    question: "Do you provide Swift Dzire airport pickup and drop service?",
    answer: "Yes, we offer Swift Dzire airport transfers to and from Belgaum Airport and other nearby locations."
  },
  {
    question: "Is Swift Dzire suitable for corporate travel?",
    answer: "Yes, Swift Dzire is a perfect choice for business meetings, office travel, client visits, and executive transportation."
  },
  {
    question: "Can I book Swift Dzire for a full day?",
    answer: "Yes, daily rental packages are available for sightseeing, local travel, business requirements, and personal use."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Is Swift Dzire rental available 24/7 in Belgaum?",
    answer: "Yes, our Swift Dzire rental service is available 24 hours a day for local, airport, and outstation travel."
  },
  {
    question: "Can I hire Swift Dzire for family trips?",
    answer: "Yes, Swift Dzire is an economical and comfortable option for small families, couples, and personal travel."
  },
  {
    question: "How can I book a Swift Dzire on Rent in Belgaum?",
    answer: "Share your pickup location, destination, travel date, passenger details, and rental duration to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Desai",
    feedback: "We rented a Swift Dzire for our Belgaum trip and had a great experience. The car was clean, comfortable, and the driver was punctual and professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback: "The Swift Dzire rental service was affordable and convenient. The booking process was easy, and the overall journey was smooth and comfortable.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/swift-dzire-on-rent-in-belgaum.webp",
  "description":
    "Book Swift Dzire On Rent in Belgaum with Belgaum Taxi Service for affordable and comfortable taxi rental services. We provide Maruti Swift Dzire rentals for local travel, airport transfers, outstation trips, corporate travel, and one-way journeys with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/swift-dzire-on-rent-in-belgaum"
  }
};






    return (
        <div>

<Helmet>
  <title>Swift Dzire On Rent in Belgaum | Dzire Cab Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Swift Dzire On Rent in Belgaum with Belgaum Taxi Service for reliable and affordable cab rental services. Hire Maruti Swift Dzire for local trips, airport transfers, outstation travel, corporate journeys, and one-way taxi services with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Swift Dzire On Rent in Belgaum, Swift Dzire Rent in Belgaum, Swift Dzire Rental Belgaum, Maruti Swift Dzire on Rent Belgaum, Swift Dzire Cab Service Belgaum, Swift Dzire Taxi Service Belgaum, Swift Dzire Taxi Belgaum, Swift Dzire Cab Booking Belgaum, Swift Dzire Car Hire Belgaum, Swift Dzire Outstation Cab Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentinbelgaum;